var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9949 14.4766C15.2734 14.4766 15.5 14.7061 15.5 14.9883C15.5 15.271 15.2734 15.5 14.9949 15.5H12.1398C11.8613 15.5 11.6347 15.271 11.6347 14.9883C11.6347 14.7061 11.8613 14.4766 12.1398 14.4766H14.9949ZM13.0149 6.84953L13.7524 7.43539C14.0549 7.67189 14.2565 7.98363 14.3255 8.31149C14.405 8.67215 14.3202 9.02635 14.0814 9.33272L9.6882 15.014C9.48658 15.2719 9.18945 15.4171 8.87111 15.4224L7.1202 15.4439C7.02469 15.4439 6.94511 15.3794 6.92388 15.2881L6.52595 13.5627C6.45697 13.2456 6.52595 12.9178 6.72757 12.6651L9.84207 8.63399C9.89512 8.56949 9.99063 8.55928 10.0543 8.60711L11.3648 9.64984C11.4497 9.71971 11.5664 9.75733 11.6885 9.74121C11.9485 9.70896 12.1236 9.47247 12.097 9.21985C12.0811 9.09085 12.0174 8.98335 11.9325 8.90273C11.906 8.88123 10.6592 7.88151 10.6592 7.88151C10.5796 7.81701 10.5637 7.69876 10.6273 7.61867L11.1208 6.97853C11.5771 6.39267 12.3729 6.33892 13.0149 6.84953Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit_profile.72addea49a66712711c22ab726c707f5.svg";
export { ForwardRef as ReactComponent };